function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconQrCodeRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 24H2v6h6v-2H4v-4zM4 4h4V2H2v6h2V4zM28 28h-4v2h6v-6h-2v4zM24 2v2h4v4h2V2h-6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 26h20V6H6v20zm12-2h-2v-2h2v2zm0-16h6v10h-2v-4h-4V8zM8 18h2v-2h2v2h4v-2h-2v-2H8V8h6v2h2v2h-2v2h2v2h4v4h4v2h-2v2h-2v-4h-2v-2h-2v2h-2v4H8v-6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10h-2v2h2v-2zM12 20h-2v2h2v-2zM12 10h-2v2h2v-2z",
    fill: props.color
  }));
}

export default SvgIconQrCodeRexFilled;